import { SSR_STRAPI_API } from '@trwl/strapi.api';

export const getMainLayoutData = async () => {
  const phones = await SSR_STRAPI_API.PhoneApi.getPhones().then(({ data }) => {
    return data.data ?? [];
  });

  const footerMenu = await SSR_STRAPI_API.MenuApi.getMenusId(2, {
    params: {
      populate: '*',
    },
  }).then(({ data }) => {
    return data.data?.attributes?.children?.data ?? [];
  });

  const headerMenu = await SSR_STRAPI_API.MenuApi.getMenusId(1, {
    params: {
      populate: '*',
    },
  }).then(({ data }) => {
    return data.data?.attributes?.children?.data ?? [];
  });

  const contacts = await SSR_STRAPI_API.ContactApi.getContacts(
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    '*',
  ).then(({ data }) => {
    return data.data ?? [];
  });

  return {
    phones,
    contacts,
    footerMenu,
    headerMenu,
  };
};
